export const JOB_HAS_BEEN_SAVED_AS_FAVORITE = "JOB_HAS_BEEN_SAVED_AS_FAVORITE";

type JobSavedAsFavorite = {
  savedJob: { id: string; job: string };
  appendFilters: boolean;
  search: string;
};

export const jobHasBeenSavedAsFavorite = ({
  savedJob,
  appendFilters,
  search,
}: JobSavedAsFavorite) => {
  return {
    type: JOB_HAS_BEEN_SAVED_AS_FAVORITE,
    payload: {
      savedJob,
      search,
      appendFilters,
    },
  };
};
